var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-view", { on: { "open-dialog": _vm.openDialog } }),
      _vm._v(" "),
      _c("permission-cookie"),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "announcement-dialog",
          attrs: {
            title: _vm.detail.type === 1 ? "Announcement" : "",
            width: "768px",
            visible: _vm.showContent,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showContent = $event
            }
          }
        },
        [
          _vm.detail.type === 1
            ? [
                _c("div", { staticClass: "title" }, [
                  _vm._v("\n        " + _vm._s(_vm.detail.title) + "\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm._v("\n        " + _vm._s(_vm.detail.content) + "\n      ")
                ])
              ]
            : _c("div", { staticClass: "img-content" }, [
                _c("img", {
                  attrs: {
                    src: _vm.detail.fileImgSrc,
                    width: "728px",
                    height: "auto",
                    alt: ""
                  }
                })
              ]),
          _vm._v(" "),
          _vm.detail.type === 1
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        height: "32px",
                        "line-height": "32px",
                        padding: "0 20px"
                      },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.showContent = false
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("check-code")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 